import AxiosConfig from '@/config/axios-config'

export const CategoriaAPI = {

  listarCategorias () {
    return AxiosConfig.secureJalekoAPI().get('/categorias').then(response => response.data)
  },

  listarCategoriasHome () {
    return AxiosConfig.secureJalekoAPI().get('/categorias/home').then(response => response.data)
  },

  listarSistemas () {
    return AxiosConfig.secureJalekoAPI().get('/categorias/sistemas/cursos').then(response => response.data)
  },

  listarDisciplinas () {
    return AxiosConfig.secureJalekoAPI().get('/categorias/disciplinas/cursos').then(response => response.data)
  }

}

export default CategoriaAPI
